// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import type { JsonValueType } from '../inputTypeSchemas/JsonValueSchema';
import { ApplicationWithRelationsSchema } from './ApplicationRelationsSchema'
import type { ApplicationWithRelations } from './ApplicationRelationsSchema'
import { AiComponentRelationWithRelationsSchema } from './AiComponentRelationRelationsSchema'
import type { AiComponentRelationWithRelations } from './AiComponentRelationRelationsSchema'
import { AssetLifecycleSchema } from './AssetLifecycleSchema'
import type { AssetLifecycle } from './AssetLifecycleSchema'
import { AiComponentSchema } from './AiComponentSchema';

/////////////////////////////////////////
// AI COMPONENT RELATION SCHEMA
/////////////////////////////////////////

export type AiComponentRelations = {
  application: ApplicationWithRelations;
  outgoingEdges: AiComponentRelationWithRelations[];
  incomingEdges: AiComponentRelationWithRelations[];
  lifecycle: AssetLifecycle;
};

export type AiComponentWithRelations = Omit<z.infer<typeof AiComponentSchema>, "runtimeOverlay" | "metadata"> & {
  runtimeOverlay?: JsonValueType | null;
  metadata?: JsonValueType | null;
} & AiComponentRelations

export const AiComponentWithRelationsSchema: z.ZodType<AiComponentWithRelations> = AiComponentSchema.merge(z.object({
  application: z.lazy(() => ApplicationWithRelationsSchema),
  outgoingEdges: z.lazy(() => AiComponentRelationWithRelationsSchema).array(),
  incomingEdges: z.lazy(() => AiComponentRelationWithRelationsSchema).array(),
  lifecycle: z.lazy(() => AssetLifecycleSchema),
}))